module.exports = __webpack_public_path__ + "img/lzreading.e83c066d.png";